import { render } from "./SupporterView.vue?vue&type=template&id=d79543b4"
import script from "./SupporterView.vue?vue&type=script&lang=js"
export * from "./SupporterView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/timon/git/uni/eunet/participants-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__